/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useState } from "react";
import { PrivateContext } from "../routes/private/privateContext";
import { logout as userLogout } from "../api/logout";
import "./jquery"
import { useAppContext } from "./context";

export default function Header() {
  const { match, history } = useContext(PrivateContext);
  const [, dispatch] = useAppContext();
  const [loading, setLoading] = useState(false);
  // const [isLogout, set]
  const { location: { hash } } = history;
  const { path } = match;
  const hashR = (hash && hash.replace("#", "")) || "";
  const route = (hashR && hashR.replace(hashR, `/${hashR}`)) || "";
  const active = route === ""? path: route;

  const logout = async (event) => {
    event.preventDefault();
    setLoading(true);
    const res = await userLogout();
    if (res.status === "ok") {
      dispatch({
        type: "user",
        user: {},
      });
      
      history.push("/home")
    }
    
    setLoading(false);
  }

  return (
    <header id="header" className="fixed-top">
    <div className="container d-flex align-items-center">

      <h1 className="logo mr-auto" style={{color: "blue"}}><a href="/">ARA Learning Academy</a></h1>
      {/* <!-- Uncomment below if you prefer to use an image logo --> */}
      {/* <a href="index.html" className="logo mr-auto"><img src="assets/img/logo.png" alt="" className="img-fluid"/></a> */}

      <nav className="nav-menu d-none d-lg-block">
        <ul>
          <li className={((active) === "/" && "active") || ""}><a href="/">Home</a></li>
          <li className={((active) === "/abouts" && "active") || ""}><a href="/abouts">About</a></li>
          <li className={((active) === "/course" && "active") || ""}><a href="/course">Courses</a></li>
          {/* <li className={(active) === "/trainers" && "active"}><a href="#trainers">Trainers</a></li> */}
          {/* <li><a href="events.html">Events</a></li>
          <li><a href="pricing.html">Pricing</a></li> */}
          <li className="drop-down"><a>Faculty</a>
            <ul>
            <li className={((active) === "/trainers" && "active") || ""}><a href="/trainers">Trainers</a></li>
            <li className={((active) === "/advisors" && "active") || ""}><a href="/advisors">Advisors</a></li>
            </ul>
          </li>

        </ul>
      </nav>
      {/* <!-- .nav-menu --> */}

      <button onClick={(event) => logout(event)} className="get-started-btn">
          {loading ? <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div> : "Log Out"}
      </button>

    </div>
  </header>
  );
} 